export const getKey = (id: string, index: number): string => `${id}-${index}`;
